export const FETCH_GET_IFRAME_DATA = 'FETCH_GET_IFRAME_DATA'
export const FETCH_GET_IFRAME_DATA_SUCCESS = 'FETCH_GET_IFRAME_DATA_SUCCESS'

export const fetchGetDataIframe = (token) => {
    return {
        type: FETCH_GET_IFRAME_DATA,
        payload: {
            token: token
        }
    }
}